module.exports = __webpack_public_path__ + "img/slider-19.1261248f.jpg";